import axios from "axios";
import { Base_URL } from "../url";

/**
 * CREATE Department (DepartmentList)
 */
export const saveDepartmentList = async (departmentData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId;

    const response = await axios.post(
      `${Base_URL}/DepartmentList/CreateDepartment?UserName=${userId}`,
      departmentData
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving department!";
  }
};

/**
 * GET ALL Departments
 */
export const getAllDepartmentList = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/DepartmentList/GetAllDepartments`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching departments!";
  }
};

/**
 * GET Department By Code
 */
export const getDepartmentListByCode = async (deptCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/DepartmentList/GetDepartmentByCode`,
      { deptCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching department!";
  }
};

/**
 * UPDATE Department
 */
export const updateDepartmentList = async (departmentData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId;

    const response = await axios.put(
      `${Base_URL}/DepartmentList/UpdateDepartment?UserName=${userId}`,
      departmentData
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating department!";
  }
};

/**
 * DELETE Department
 */
export const deleteDepartmentList = async (deptCode) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/DepartmentList/DeleteDepartment/${deptCode}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting department!";
  }
};

/**
 * DOWNLOAD Department List Excel
 */
export const downloadDepartmentListExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/DepartmentList/DownloadDepartmentsExcel`,
      {},
      { responseType: "blob" }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "DepartmentList.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    throw error.response?.data || "Error downloading Excel!";
  }
};
